module.exports = __webpack_public_path__ + "statics/img/cate2-6@2x.fa5dac70.png";